import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import useSort from '@shared/hooks/useSort';
import { useRemainVacationQuery, useVacationListQuery } from '@features/vacation/hooks';
import useVacationStatus from '@features/vacation/hooks/useVacationStatus';

// 휴가 현황 목록 훅
export default function useVacationRequestPage() {
  const queryClient = useQueryClient();
  const currentYear = new Date().getFullYear();

  const [queryYear, setQueryYear] = useState(currentYear.toString());
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 15;

  const { data: remainVacationData } = useRemainVacationQuery();

  const { data: vacationListData, isLoading } = useVacationListQuery(Number(queryYear));

  //휴가 현황
  const vacationStatus = useVacationStatus(remainVacationData);

  // useSort 훅 사용 (신청일자 기준 내림차순 기본)
  const { sortedData, sortField, sortDirection, handleSort } = useSort(vacationListData || [], {
    field: 'date',
    direction: 'desc',
  });

  const totalItems = sortedData.length;
  const currentPageData = sortedData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  function refetchAll() {
    /**
     * 휴가 등록/변경 후 데이터 최신화 처리
     *
     * - vacationList 쿼리는 queryKey에 year가 포함되어 있음
     *   → 단순 refetch 호출로는 캐시가 갱신되지 않는 경우가 발생
     * - React Query 권장 방식에 따라 invalidateQueries 사용
     * - remainVacation, vacationList(year) 쿼리를 명시적으로 무효화하여
     *   다음 렌더링 시 최신 데이터로 재조회되도록 처리
     */
    queryClient.invalidateQueries({ queryKey: ['remainVacation'] });
    queryClient.invalidateQueries({
      queryKey: ['vacationList', Number(queryYear)],
    });
    // refetchList();
    // refetchRemain();
  }

  return {
    queryYear,
    setQueryYear,
    currentPage,
    setCurrentPage,
    pageSize,
    totalItems,
    tableData: currentPageData,
    vacationStatus,
    isLoading,
    sort: { sortField, sortDirection, handleSort },
    refetchAll,
  };
}
